export { default as TableDetails } from './TableDetails';
export { default as TableSDM17SPG } from './TableSDM17SPG';
export { default as TableSDM17DEC } from './TableSDM17DEC';



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/User/Table/index.js